import { ReadFieldFunction } from '@apollo/client/cache/core/types/common';
import { Reference } from '@apollo/client';

import { InvoicePureType, InvoiceState, InvoiceType, LicensePaymentState } from '@shared/api/graphql/generated';

export type InvoiceShortType = Pick<InvoicePureType, 'id' | 'type' | 'status' | 'amount'>;

export const hasWaitPaymentLicense = (licenses: Reference[], readField: ReadFieldFunction): boolean =>
  !!licenses?.find(
    (license) => readField<LicensePaymentState>('paymentState', license) === LicensePaymentState.WaitPayment
  );

export const hasGraceLicense = (licenses: Reference[], readField: ReadFieldFunction): boolean =>
  !!licenses?.find((license) => readField<LicensePaymentState>('paymentState', license) === LicensePaymentState.Grace);

export const getLastPaidPeriodicInvoice = <T extends InvoiceShortType = InvoicePureType>(
  invoices: T[]
): T | undefined =>
  [...invoices]
    .sort((a, b) => Number(b.id) - Number(a.id))
    .find((invoice) => invoice.type === InvoiceType.Periodic && invoice.status === InvoiceState.Paid);
